import axios from "@/axios";

export const namespaced = true;

export const state = {
  documentTypes: null,
  documents: [],
  allUserDocuments: [],
  userDocuments: [],
  form: {
    orderId: null,
    documentType: [],
    remark:"",
    file: null,
  },
  uploading: false,
  downloadFileData: null,
};

export const getters = {
  documentTypes: (state) => {
    return state.documentTypes;
  },
  getDocuments: (state) => {
    return state.documents;
  },
  getAllUserDocuments: (state) => {
    return state.allUserDocuments;
  },
  getUserDocuments: (state) => {
    return state.userDocuments;
  },

  //return document by id Note: may want to filter the gerUserDocuments since it's a smaller dat set. See the API route -KM
  userDocumentById: (state) => (id) => {
    return state.allUserDocuments.find(
      (UserDocuments) => UserDocuments.id === id
    );
  },

  form: (state) => {
    return state.form;
  },
  uploadingStatus: (state) => {
    return state.uploading;
  },
  downloadFileData: (state) => {
    return state.downloadFileData;
  },
};

export const mutations = {
  SET_DOCUMENT_TYPES(state, documentTypes) {
    state.documentTypes = documentTypes;
  },
  SET_DOCUMENTS(state, documents) {
    state.documents = documents;
  },
  SET_ALL_USER_DOCUMENTS(state, documents) {
    state.allUserDocuments = documents;
  },
  SET_USER_DOCUMENTS(state, documents) {
    state.userDocuments = documents;
  },
  SET_UPLOADING_STATUS(state, status) {
    state.uploading = status;
  },
  SET_FORM_DATA(state, formData) {
    state.form = formData;
  },
  CLEAR_FORM_DATA(state) {
    state.form = {
      orderId: null,
      documentType: null,
      remark: "",
      file: null,
    };
    state.uploading = false;
  },
  CLEAR_DOCUMENTS_DATA(state) {
    state.documents = [];
    state.form = {
      orderId: null,
      documentType: null,
      remark: "",
      file: null,
    };
    state.uploading = false;
  },
  SET_DOCUMENTS(state, data) {
    state.documents = data;
  },
  STORE_DOWNLOAD_FILE_DATA(state, data) {
    state.downloadFileData = data;
  },
  SET_DOCUMENT_TYPE(state, docType) {
    state.form.documentType = docType;
  },
  DISABLE_OTHER_EDITS(state, currentDoc) {
    state.documents.forEach(doc => {
      if(doc.id !== currentDoc) {
        doc.editMode = false;
      }
    })
  }
};

export const actions = {
  clearData({ commit }) {
    commit("CLEAR_DOCUMENTS_DATA");
  },
  updateDocumentType({ commit }, docType) {
    commit("SET_DOCUMENT_TYPE", docType);
  },
  disabledOtherEdits({commit}, currentDoc) {
    commit("DISABLE_OTHER_EDITS", currentDoc);
  },
  async getDocumentTypes({ commit }) {
    await axios
      .get("/api/orderfiletypes")
      .then((res) => {
        commit("SET_DOCUMENT_TYPES", res.data);
      })
      .catch((err) => {
        console.log(err); //not handelled
      });
  },

  // Get User Documents By ID -KM
  async getUserDocumentsById({ commit }, userId) {
    await axios
      .get("api/applicationuserfiles/user/id/" + userId)
      .then((res) => {
        if (res.data.length > 0) {
          commit("SET_USER_DOCUMENTS", res.data);
        } else {
          // No Documents found.
          commit("SET_USER_DOCUMENTS", []);
        }
      })
      .catch((err) => {
        console.log(err); //not handelled
      });
  },
  //Get User Documents By Email -KM
  async getUserDocumentsByEmail({ commit }, userEmail) {
    const encodeEmail = encodeURIComponent(userEmail);
    await axios
      .get(`api/applicationuserfiles/user/email/${encodeEmail}`) // Encoded email - Bug fix #17661
      .then((res) => {
        if (res.data.length > 0) {
          commit("SET_USER_DOCUMENTS", res.data);
        } else {
          // No Documents found.
          commit("SET_USER_DOCUMENTS", []);
        }
      })
      .catch((err) => {
        console.log(err); //not handelled
      });
  },
  async getAllUsersDocuments({ commit }) {
    await axios
      .get("api/applicationuserfiles")
      .then((res) => {
        if (res.data.length > 0) {
          // let docs = res.data.map((row) => {
          //   return {
          //     ...row,
          //     editMode: false,
          //   };
          // });
          commit("SET_ALL_USER_DOCUMENTS", res.data);
        } else {
          // No Documents found.
          commit("SET_ALL_USER_DOCUMENTS", []);
        }
      })
      .catch((err) => {
        console.log(err); //not handelled
      });
  },

  //old version of get documents with old route
  async getDocuments({ commit }, orderId) {
    await axios
      .get("/api/orderfiles/order/" + orderId)
      .then((res) => {
        if (res.data.length > 0) {
          let docs = res.data.map((row) => {
            return {
              ...row,
              editMode: false,
              canChangeDocumentType: true,
            };
          });
          commit("SET_DOCUMENTS", docs);
        } else {
          // No Documents found.
          commit("SET_DOCUMENTS", []);
        }
      })
      .catch((err) => {
        console.log(err); //not handelled
      });
  },

  async getFileSignature({ commit, state }) {
    try {
      const response = await axios.get(`api/orderfiles/signature`);
      return `data:image/jpg;base64,${response.data}`;
    } catch (error) {
      console.log("ERROR: ", error); //not handelled
    }
  },
  // Saving the Document and uploadingthe file to server using formdata
  async saveDocument({ dispatch }, formData) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/orderfiles", formData)
        .then((response) => {
          dispatch("getDocuments", formData.get("OrderId"));
          return resolve();
        })
        .catch((err) => {
          return reject(err);
        });
    });
  },
  clearNewDocumentData({ commit }) {
    commit("CLEAR_FORM_DATA");
  },
  async updateDocument({ dispatch, state }, row) {
    let formData = new FormData();
    // Iterate through the fileTypeNames

    row.fileTypeNames.forEach((fileName) => {
      let fileId = state.documentTypes.find((o) => o.name == fileName);
      formData.append("FileTypeIds", fileId.id);
    });

    /*  let documentType = state.documentTypes.find(
      (o) => o.name == row.fileTypeNames[0]
    ); */

    formData.append("Id", row.id);

    formData.append("OrderId", row.orderId);
    formData.append("Remark", row.remark);

    let response = await axios
      .put("/api/orderfiles", formData, {config: {showToast: false}})
      .then((res) => {
        dispatch("getDocuments", row.orderId);
      })
      .catch((err) => {
        console.log(err); //not handelled
      });
  },
  // Deleting the file from server
  async deleteDocument({ dispatch }, { row, deletionReason = null }) {
    let response = ""
    let url = "/api/orderfiles/archive/" + row.id;
    if (deletionReason) {
      url += `?deletionReason=${encodeURIComponent(deletionReason)}`;
    }
    
    await axios
      .delete(url, {config: {showToast: false}})
      .then((res) => {
        response = res
        dispatch("getDocuments", row.orderId);
      })
      .catch((err) => {
        response = err
      });

    return response;
  },
  // Fetching the File BLob from server
  downloadDocument({ commit }, row) {
    axios({
      url: "/api/orderfiles/" + row.id,
      method: "GET",
      responseType: "blob", // important
    })
      .then((res) => {
        commit("STORE_DOWNLOAD_FILE_DATA", res);
      })
      .catch((err) => {
        console.log(err); //not handelled
      });
  },
};
